import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User} from '../models/user';
import { HttpHeaders } from '@angular/common/http';
import { DeviceDetectorService } from 'ngx-device-detector';

const httpOptions = {
  headers: new HttpHeaders({
    "content-type": "application/x-www-form-urlencoded",
    Authorization: 'Basic YWJlbnRvdW1pQGNpYWdlLmZyOjEyMzQ1Ng=='
  })
};

@Injectable({
  providedIn: 'root'
})
export class AuthentificationService{
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;

  public user: User;
  private isMobileResolution: boolean;
  constructor(private http: HttpClient,  private deviceService: DeviceDetectorService) { 
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.isMobileResolution =  this.deviceService.isMobile();
    
  }

public get currentUserValue(): User {
    return this.currentUserSubject.value;
}
public get userValue(): User {
  return this.user;
}

login(username: string, password: string) {
    let body ={
      "email":username,
      "password":password
    }
    return this.http.post<User>('https://simulateur.simuleo.com/simulation/simuleo/login_api', body )
      .pipe(map(user => {
            if (user) {
              console.log(user.data_user);
              localStorage.setItem('currentUser', JSON.stringify(user));
              this.currentUserSubject.next(user);
          }

          return user;
      }));
}

logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('currentUser');
  this.currentUserSubject.next(null);
}

isMobile()
{
  return this.isMobileResolution 
}

showHeader(){

  //this.displayHeader = true;

}

hideHeader(){

  //this.displayHeader = false;
}

getDisplayHeader(){

  return  ;
}


}
